// import Desktop from "./libs/Desktop";
// import MobileV2 from "./libs/MobileV2";
import { withTranslation } from "next-i18next";
import useResponsive from "@helpers/useResponsive";
import type { TProducts } from "./type";
import dynamic from "next/dynamic";

const Desktop = dynamic(() => import("./libs/Desktop"));
const MobileV2 = dynamic(() => import("./libs/MobileV2"));

const ProductLevelZero: React.FC<TProducts> = (props) => {
  const isMobile = useResponsive("md");
  const Component = isMobile ? MobileV2 : Desktop;
  return <Component {...props} />;
};

export default withTranslation(["common"])(ProductLevelZero);
